module.exports = __webpack_public_path__ + "img/aerospace-pathway.38ef94e7.jpg";